export const clearStorageExcept = (
	storage: Storage | null,
	keys: readonly string[]
): void => {
	if (!storage) {
		return;
	}

	try {
		const keysToKeep = new Set(keys);
		const keysToRemove: string[] = [];

		for (let index = 0; index < storage.length; index += 1) {
			const key = storage.key(index);

			if (key != null && !keysToKeep.has(key)) {
				keysToRemove.push(key);
			}
		}

		for (const key of keysToRemove) {
			storage.removeItem(key);
		}
	} catch {
		/* noop */
	}
};
